define('view/form/primary.contact.finder.content.view',['require','exports','module','underscore','./person.finder.content.view'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      PersonFinderContentView = require('./person.finder.content.view');

  var PrimaryContactFinderPreviewAnswerInsideTableView = PersonFinderContentView.PreviewAnswerInsideTableView.extend({
    options: _.extend({}, PersonFinderContentView.PreviewAnswerInsideTableView.prototype.options, {
      modalFinderOptions: {
        canShowPeopleWithoutAccount: false,
      },
    }),
  });

  var PrimaryContactFinderPreviewAnswerView = PersonFinderContentView.PreviewAnswerView.extend({
    options: _.extend({}, PersonFinderContentView.PreviewAnswerView.prototype.options, {
      modalHeaderText: 'Primary Contact Finder',
      modalFinderOptions: {
        canShowPeopleWithoutAccount: false,
      },
    }),

    internalViewOptions: PersonFinderContentView.PreviewAnswerView.extendInternalViewOptions({
      finderTableView: function() {
        return {
          emptyText: 'No Primary Contact has been selected.',
        };
      },
      addButtonView: function() {
        return {
          text: 'Find Primary Contact',
        };
      },
    }),
  });

  var PrimaryContactFinderContentView = PersonFinderContentView.extend({
    internalViewOptions: PersonFinderContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PrimaryContactFinderPreviewAnswerView,
        };
      },
    }),
  });

  PrimaryContactFinderContentView.PreviewAnswerView = PrimaryContactFinderPreviewAnswerView;
  PrimaryContactFinderContentView.PreviewAnswerInsideTableView = PrimaryContactFinderPreviewAnswerInsideTableView;

  module.exports = PrimaryContactFinderContentView;
});

